import { useState } from 'react';
import { InventoryGrid } from '@/components/inventory/InventoryGrid';
import { SkillTree } from '@/components/skills/SkillTree';
import { Tabs } from '@/components/ui/Tabs';

type Tab = 'inventory' | 'skills';

export function PlayerMenuScreen() {
  const [tab, setTab] = useState<Tab>('inventory');
  return (
    <div
      className="flex-1 overflow-y-auto pb-24 px-4 pt-4 space-y-4"
      style={{ paddingTop: 'calc(env(safe-area-inset-top) + 1rem)' }}
    >
      <div className="flex items-center justify-between">
        <h1 className="font-display text-2xl text-white">Персонаж</h1>
      </div>
      <Tabs<Tab>
        tabs={[
          { id: 'inventory', label: '🎒 Инвентарь' },
          { id: 'skills', label: '🌟 Умения' },
        ]}
        active={tab}
        onChange={setTab}
      />
      {tab === 'inventory' ? <InventoryGrid /> : <SkillTree />}
    </div>
  );
}
